import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconWhiteboard1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"whiteboard-1, artboard"} maskId="square-filled-radius-0-stroke-1-IconWhiteboard1"><path d="M12.5 2H11.5V4H2V19H8.19098L6.82918 21.7236L7.72361 22.1708L9.30902 19H11.5V21H12.5V19H14.691L16.2764 22.1708L17.1708 21.7236L15.809 19H22V4H12.5V2Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconWhiteboard1;
